import { hooks } from '@yola/ws-sdk';
import constants from '../constants';
import trackEvent from './track-event';

const handler = ({ blockId, variationId }) => {
  trackEvent(constants.events.BLOCK_CUTOUT, {
    targetBlockId: blockId,
    targetBlockVariationId: variationId,
  });
};

const trackBlockCutout = () => {
  hooks.operations.subscribe(hooks.availableHooks.ON_AFTER_BLOCK_CUTOUT, handler);
};

export default trackBlockCutout;
